/**
 * Whether the loan is closed to payment activity.
 *
 * The payments service resolves this rule and returns it as readOnlyIndicator: a dead
 * loan, or an inactive/suspended loan that is already paid off. An Elevate status code on
 * its own (SUSCODE populated, or CODE "T") must not stop a borrower who still owes money
 * from paying, so payment routes are gated on this instead of on the raw indicators.
 *
 * Falls back to the raw indicators when the field is absent, as it is in mocked loan data.
 */
export const isLoanClosedToPayments = (loanDetails) => {
  if (typeof loanDetails?.readOnlyIndicator === "boolean") {
    return loanDetails.readOnlyIndicator;
  }

  return !!(
    loanDetails?.inActiveIndicator ||
    loanDetails?.suspendedIndicator ||
    loanDetails?.deadLoanIndicator
  );
};
